// import React, { useEffect, useState } from "react";
// import { BASE_URL, USER_URL } from "../../constant/api";
// import axios from "axios";
// import { BsBoxSeam } from "react-icons/bs";
// import { Link } from "react-router-dom";
// import DeleteModal from "../../components/DeleteModal/DeleteModal";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import ScaleLoader from "react-spinners/ScaleLoader";

// function SellerOffer() {
//     const [offers, setOffers] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const token = localStorage.getItem("token");
//     const [showConfirm, setShowConfirm] = useState(false);
//     const [selectedOffer, setSelectedOffer] = useState(null); // For delete confirmation

//     // Fetch offers on component mount
//     useEffect(() => {
//         const fetchOffers = async () => {
//             try {
//                 const response = await USER_URL.get("/offers/seller/special-offer/");
//                 if (response.data?.Data) {
//                     setOffers(response.data.Data);
//                 }
//                 console.log(response);
//                 setIsLoading(false);
//             } catch (error) {
//                 console.error("Error fetching offers:", error.message || error);
//                 setIsLoading(false);
//             }
//         };
//         fetchOffers();
//     }, [token]);

//     // Handle delete confirmation
//     const handleDelete = async () => {
//         if (selectedOffer) {
//             try {
//                 await USER_URL.delete(`/offers/seller/special-offer/${selectedOffer.id}/`);
//                 setOffers(offers.filter((o) => o.id !== selectedOffer.id));
//                 setShowConfirm(false);
//                 setSelectedOffer(null);
//                  toast.success("Offer Delete successfully!");
//             } catch (error) {
//                 console.error("Error deleting product:", error.message || error);
//             }
//         }
//     };

//     return (
//         <div className="container mx-auto px-4">
//             <ToastContainer position="top-center" autoClose={3000} />
//             <div className="flex justify-end items-center mt-5 mr-5">
//                 <Link
//                     to="/seller/offer_brand/Offer/Add"
//                     className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg shadow"
//                 >
//                     + Add New Offer
//                 </Link>
//             </div>
//             {/* Table Section */}
//             <div className="overflow-x-auto">
//                 {isLoading ? (
//                     // Show loading spinner
//                     <div className="flex justify-center items-center h-64">
//                         <ScaleLoader color="#FFAE00" height={40} />
//                     </div>
//                 ) : offers.length === 0 ? (
//                     // Show no offers message
//                     <div className="text-center mt-10">
//                         <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
//                         <p className="text-lg text-gray-600">No special offers available</p>
//                     </div>
//                 ) : (
//                     <>
//                         {/* Table Header */}
//                         <div className="w-full space-y-4 mt-10">
//                             <div className="min-w-[800px] grid grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
//                                 <div className="text-center">Item No</div>
//                                 <div className="text-center">Title</div>
//                                 <div className="text-center">Start Date</div>
//                                 <div className="text-center">End Date</div>
//                                 <div className="text-center">Edit</div>
//                                 <div className="text-center">Delete</div>
//                                 <div className="text-center">View</div>
//                             </div>
//                         </div>

//                         {/* Table Body */}
//                         {offers.map((offer, index) => (
//                             <div
//                                 key={offer.id}
//                                 className="grid text-[#2F2E41] min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr] items-center gap-2 py-2"
//                             >
//                                 <div className="border rounded-xl p-2 text-center">{index + 1}</div>
//                                 <div className="rounded-xl border p-2 text-center">{offer.title}</div>
//                                 <div className="rounded-xl border p-2 text-center">
//                                     {new Date(offer.start_date).toLocaleDateString("en-GB")}
//                                 </div>
//                                 <div className="rounded-xl border p-2 text-center">
//                                     {/* {new Date(offer.end_date).toLocaleDateString("en-GB")} */}
//                                 </div>
//                                 <Link to={`/seller/offer_brand/Offer/Edit/${offer.id}`}>
//                                     <div className="border p-2 rounded-xl text-center border-brand-primary hover:bg-brand-primary text-brand-primary hover:text-white transition ease-in-out duration-400 cursor-pointer">
//                                         Edit
//                                     </div>
//                                 </Link>
//                                 <div
//                                 className="border p-2 rounded-xl text-center border-red-500
//                                  hover:bg-red-500 text-red-500 hover:text-white transition
//                                  ease-in-out duration-400 cursor-pointer"
//                                     onClick={() => {
//                                         setSelectedOffer(offer);
//                                         setShowConfirm(true);
//                                     }}
//                                  >
//                                     Delete
//                                 </div>
//                                 <Link to={`/seller/offer_brand/Offer/view/${offer.id}`}>
//                                     <div className="border p-2 rounded-xl text-center border-blue-500 hover:bg-blue-500 text-blue-500 hover:text-white transition ease-in-out duration-400 cursor-pointer">
//                                         View
//                                     </div>
//                                 </Link>
//                                 {/* Pay Button */}
//                         <button
//                         //   onClick={() => payNow(offer.id)}
//                           disabled={offer.payment_status !== "Pending"}
//                           className={`flex flex-1 items-center justify-center rounded-lg px-2 py-2 text-center text-xs font-medium shadow-md transition sm:text-sm ${
//                             offer.payment_status === "Pending"
//                               ? "border border-yellow-600 text-yellow-600 hover:border-yellow-700 hover:bg-yellow-700 hover:text-white"
//                               : offer.payment_status === "Paid"
//                                 ? "cursor-not-allowed border border-gray-400 bg-gray-100 text-gray-500"
//                                 : offer.payment_status === "Failed"
//                                   ? "cursor-not-allowed border border-red-400 bg-red-100 text-red-500"
//                                   : "border border-gray-300 bg-gray-100 text-gray-500"
//                           } `}
//                         >
//                           {offer.payment_status === "Pending"
//                             ? "Pay"
//                             : offer.payment_status === "Paid"
//                               ? "Paid"
//                               : offer.payment_status === "Failed"
//                                 ? "Failed"
//                                 : "Unknown"}
//                         </button>
//                             </div>
//                         ))}
//                     </>
//                 )}
//             </div>
//             {/* Delete Confirmation Modal */}
//             {showConfirm && (
//                 <DeleteModal
//                     entityName="Offer"
//                     title={selectedOffer?.title}
//                     onConfirm={handleDelete}
//                     onCancel={() => setShowConfirm(false)}
//                 />
//             )}
//         </div>
//     );
// }

// export default SellerOffer;

import React, { useEffect, useState } from "react";
import { BASE_URL, USER_URL } from "../../constant/api";
import axios from "axios";
import { BsBoxSeam } from "react-icons/bs";
import { Link } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useAuth } from "../../context/AuthContext";

function SellerOffer() {
  const [offers, setOffers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null); // For delete confirmation
  const { user } = useAuth();
  const fetchOffers = async () => {
    try {
      const response = await USER_URL.get("/products/seller/special-offer/");
      if (response.data?.Data) {
        setOffers(response.data.Data);
      }
      console.log(response);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching offers:", error.message || error);
      setIsLoading(false);
    }
  };
  // Fetch offers on component mount
  useEffect(() => {
  
    fetchOffers();
  }, [token]);

  // Handle delete confirmation
  const handleDelete = async () => {
    if (selectedOffer) {
      try {
        await USER_URL.delete(
          `/offers/seller/special-offer/${selectedOffer.id}/`,
        );
        setOffers(offers.filter((o) => o.id !== selectedOffer.id));
        setShowConfirm(false);
        setSelectedOffer(null);
        toast.success("Offer Deleted successfully!");
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
      }
    }
  };

  const payNow = async (id) => {
      try {
        const data = {
          payment_for: "special_offer", // sponsored, banner, special_offer
          object_id: id,
        };
        console.log("Payment Data:", data);
  
        const res = await USER_URL.post(
          "/orders/seller/promotion/razorpay/initiate/",
          data,
        );
        const { razorpay_order_id, amount } = res.data.payment;
        const { razorpay_key } = res.data;
        const customerOrderNumber = res.data.customer_order_number;
        // console.log(" Razorpay Order ID:", customerOrderNumber);
  
        console.log(" INIT RESPONSE", res.data);
  
        const options = {
          key: razorpay_key,
          currency: "INR",
          amount: amount,
          order_id: razorpay_order_id,
          name: "BricksnMix",
          description: "Service Payment",
          image: "/images/logo/icon_sg.png",
          handler: async function (response) {
            console.log("Payment Response:", response);
            const confirmData = {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              // customer_order_number: customerOrderNumber,
            };
            console.log("💳 Payment Confirmation Data:", confirmData);
  
            const verify = await USER_URL.patch(
              "/orders/seller/promotion/razorpay/confirm/",
              confirmData,
            );
            console.log(" Payment Verification:", verify.data);
            if (verify.data.Status === "1") {
           
              toast.success("Payment Successful")
              fetchOffers(); // Refresh the product list after payment
            } else {
             
              toast.error("Payment Failed");
            }
          },
          prefill: {
            name: user?.user_name || "User name",
            email: user?.email || "user@gmail.com",
            contact: "9999999999",
          },
          theme: {
            color: "#F37254",
          },
          modal: {
            ondismiss: function () {
              console.log(" Razorpay popup closed");
            },
          },
        };
  
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      } catch (err) {
        console.error(" Error in payNow:", err);
       
      }
    };

  return (
    <div className="container mx-auto px-4">
      <div className="mr-5 mt-5 flex items-center justify-end">
        <Link
          to="/seller/offer_brand/Offer/Add"
          className="rounded-lg bg-green-600 px-6 py-2 font-medium text-white shadow hover:bg-green-700"
        >
          + Add New Offer
        </Link>
      </div>
      {/* Table Section */}
      <div className="overflow-x-auto">
        {/* Loading Spinner */}
        {isLoading ? (
          <div className="flex h-64 items-center justify-center">
            <ScaleLoader color="#FFAE00" height={40} />
          </div>
        ) : (
          <div className="mt-4 overflow-auto">
            <table className="min-w-full text-center">
              <thead>
                <tr>
                  <th className="text-md py-2 font-bold text-green-500">
                    Item No
                  </th>
                  <th className="text-md px-2 py-2 font-bold text-green-500">
                    Banner Name
                  </th>
                  <th className="text-md px-2 py-2 font-bold text-green-500">
                    Start Date
                  </th>
                  <th className="text-md px-2 py-2 font-bold text-green-500">
                    Status
                  </th>
                  {/* <th className="px-2 py-2 text-green-500 text-md font-bold">Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {offers.length > 0 ? (
                  offers.map((product, index) => (
                    <tr key={product.id}>
                      <td className="px-3 py-3 text-sm">
                        <div className="rounded-lg border border-gray-300 py-2 text-gray-800">
                          {index + 1}
                        </div>
                      </td>
                      <td className="px-2 py-3 text-sm">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                          {product.title || "Name"}
                        </div>
                      </td>
                      <td className="px-2 py-3 text-sm">
                        <div className="rounded-xl border p-2 text-center">
                          {new Date(product.start_date).toLocaleDateString(
                            "en-GB",
                          )}
                        </div>
                      </td>
                      <td className="px-2 py-3 text-sm">
                        <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800">
                          {product.status || "P"}
                        </div>
                      </td>

                      {/* Action Buttons Row */}
                      <td className="px-4 py-3 text-sm">
                        <div className="flex gap-5">
                          {/* Pay Button */}
                          <button
                              onClick={() => payNow(product.id)}
                            disabled={product.payment_status !== "Pending"}
                            className={`flex flex-1 items-center justify-center rounded-lg px-2 py-2 text-center text-xs font-medium shadow-md transition sm:text-sm ${
                              product.payment_status === "Pending"
                                ? "border border-yellow-600 text-yellow-600 hover:border-yellow-700 hover:bg-yellow-700 hover:text-white"
                                : product.payment_status === "Completed"
                                  ? "cursor-not-allowed border border-gray-400 bg-gray-100 text-gray-500"
                                  : product.payment_status === "Failed"
                                    ? "cursor-not-allowed border border-red-400 bg-red-100 text-red-500"
                                    : "border border-gray-300 bg-gray-100 text-gray-500"
                            } `}
                          >
                            {product.payment_status === "Pending"
                              ? "Pay"
                              : product.payment_status === "Completed"
                                ? "Paid"
                                : product.payment_status === "Failed"
                                  ? "Failed"
                                  : "Unknown"}
                          </button>
                          {/* Edit Button */}
                          <Link
                            to={`/seller/offer_brand/Offer/Edit/${product.id}`}
                            className="flex flex-1 items-center justify-center rounded-lg border border-blue-600 px-2 py-2 text-center text-xs font-medium text-blue-600 shadow-md transition hover:border-blue-700 hover:bg-blue-700 hover:text-white sm:text-sm"
                          >
                            Edit
                          </Link>

                          {/* View Button */}
                          <Link
                            to={`/seller/offer_brand/Offer/view/${product.id}`}
                            className="flex flex-1 items-center justify-center rounded-lg border border-green-600 px-2 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm"
                          >
                            View
                          </Link>
                          {/* Delete Button */}
                          <button
                            className="flex flex-1 items-center justify-center rounded-lg border border-red-600 px-2 py-2 text-center text-xs font-medium text-red-600 shadow-md transition hover:border-red-700 hover:bg-red-700 hover:text-white sm:text-sm"
                            onClick={() => {
                              setSelectedOffer(product);
                              setShowConfirm(true);
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="py-4 text-center text-gray-600">
                      No banners found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="Offer"
          title={selectedOffer?.title}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default SellerOffer;
